import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { enumUtil } from "../../utils/Enum";
import { ServerRequestProtected } from "../../utils/ServerDataRequest";
import NotificationHandler from "../../utils/NotificationHandler";
import { useSelector } from "react-redux";

const TwoFactorAuth = () => {
    const API_URL = enumUtil.controller.Login
     let navigate = useNavigate();
    const location = useLocation();
    const fullResponse = location.state?.fullResponse;
    const year = new Date().getFullYear();

    console.log("Navigated Data:", fullResponse);

    const [isLoading, setisLoading] = useState(false);

    // ✅ Email Mask Function
    const maskEmail = (email) => {
        if (!email) return "";

        const [localPart, domainPart] = email.split("@");

        // Local part (before @)
        const localStart = localPart.slice(0, 2);
        const localMasked = localStart + "*".repeat(Math.max(localPart.length - 2, 0));

        // Domain part (after @)
        const [domainName, domainExt] = domainPart.split(".");
        const domainStart = domainName.slice(0, 2);
        const domainMasked = domainStart + "*".repeat(Math.max(domainName.length - 2, 0));

        return `${localMasked}@${domainMasked}.${domainExt}`;
    };

    const handleSubmit = () => {
        setisLoading(true)
        ServerRequestProtected(API_URL + "/Send2FAOTP", 'post', {
            "email": fullResponse?.email,
        }).then((response) => {
            setisLoading(false)
            navigate("../TwoFactorOTP", {
                replace: true,
                state: { fullResponse: fullResponse }
            });
            NotificationHandler('OTP Successfully Send', enumUtil.enumtoaster.success)

        }).catch((error) => {
            setisLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    };

        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");

    return (
        <>
            <div className="ar_login-screen">
                <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                    <div className="login-content">

                        <div className="d-flex flex-column align-items-center mb-4 pb-1-5">
                            <p className='fs-20 heading lh-normal'>Two-Factor Authentication</p>
                            <p className='text fs-11 color-muted lh-normal'>
                                Select how you want to receive OTP to verify your account.
                            </p>
                        </div>

                        <div className="d-flex flex-column gap-20 br-bottom-1 za_br_light pb-4 mb-4">
                            <div>
                                <p className="text fs-14 mb-2">Please select 2FA verification method:</p>

                                <label className="d-flex align-items-center gap-6">
                                    <input
                                        type="radio"
                                        id="CardView"
                                        checked
                                        readOnly
                                    />
                                    <p className="heading fs-13">
                                        Email Address: {maskEmail(fullResponse?.email)}
                                    </p>
                                </label>
                            </div>

                            <div className='position-relative login-btn-loader'>
                                <input
                                    type="submit"
                                    value={`${isLoading ? '' : 'Continue'}`}
                                    className="btn rounded btn-orange heading w-100"
                                    onClick={handleSubmit}
                                />

                                {isLoading && (
                                    <div className='last_loader ar-small-loader'>
                                        <div className="circle circle1"></div>
                                        <div className="circle circle2"></div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-center">
                            <p className='text fs-12 color-95 '>
                                ©{year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TwoFactorAuth;
